module.exports = __webpack_public_path__ + "static/media/kpmg.ab522892.jpg";